import { Card, Typography } from "antd";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const { Title } = Typography;

interface EvolutionData {
  year: number;
  created: number;
  closed: number;
}

interface Props {
  data: EvolutionData[];
  loading?: boolean;
}

export const ControlPointEvolutionChart = ({ data, loading }: Props) => {
  return (
    <Card loading={loading}>
      <Title level={5}>Evolución de Puntos de Control por Año</Title>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="created"
            stroke="#52c41a"
            name="Creados"
            strokeWidth={2}
          />
          <Line
            type="monotone"
            dataKey="closed"
            stroke="#ff4d4f"
            name="Cerrados"
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </Card>
  );
};
